import React from 'react'
import { Spin } from 'antd'
import styles from './PageLoading.module.css'

const PageLoading = () => (
  <Spin className={styles.container} spinning={true} size="large"/>
)

export default PageLoading
